package com.willandsons.lovenearby.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initPrivacyPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("Privacy.md", FrontMatterElement.Builder { addScalar("title", "Privacy Policy"); }))
}

@Page("/privacy")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun PrivacyPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("privacy-policy") }) {
        org.jetbrains.compose.web.dom.Text("PRIVACY POLICY")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("last-updated-august-2026") }) {
        org.jetbrains.compose.web.dom.Text("Last updated: August 2026")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The protection of your personal data is paramount to us. ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Willandsons Services SRL")
        }
        org.jetbrains.compose.web.dom.Text(" processes personal data in strict accordance with Regulation (EU) 2016/679 (General Data Protection Regulation - \"GDPR\") and applicable Romanian national laws.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("1-personal-data-controller") }) {
        org.jetbrains.compose.web.dom.Text("1. PERSONAL DATA CONTROLLER")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The personal data controller is Willandsons Services SRL, headquartered in Târgu Mureș, str. Parangului, nr.56/37, Mureș county, Romania. Registered at the Trade Register Office under J26/1757/2022, Unique Registration Code RO46847721.")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Data Protection Contact:  ")
                com.varabyte.kobweb.silk.components.navigation.Link("mailto:groszvilmos@willandsons.com") {
                    org.jetbrains.compose.web.dom.Text("groszvilmos@willandsons.com")
                }
                org.jetbrains.compose.web.dom.Text(" , +40744117278")
            }
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("2-categories-of-data-and-purposes-of-processing") }) {
        org.jetbrains.compose.web.dom.Text("2. CATEGORIES OF DATA AND PURPOSES OF PROCESSING")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("A. Registration & Profiling Data")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Data collected:")
            }
            org.jetbrains.compose.web.dom.Text(" Name, email, gender, photo.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Purpose:")
            }
            org.jetbrains.compose.web.dom.Text(" To create your profile and deliver the matchmaking service.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Legal Basis:")
            }
            org.jetbrains.compose.web.dom.Text(" Performance of a contract (Art. 6 (1) (b) GDPR).")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("B. Special Categories of Data (Sensitive Data)")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Data collected:")
            }
            org.jetbrains.compose.web.dom.Text(" Profile photos and any sensitive information you voluntarily add to your bio.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Purpose:")
            }
            org.jetbrains.compose.web.dom.Text(" Core functionality of a dating platform.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Legal Basis:")
            }
            org.jetbrains.compose.web.dom.Text(" Your ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("explicit consent")
            }
            org.jetbrains.compose.web.dom.Text(" (Art. 9 (2) (a) GDPR), provided upon registration. You can withdraw consent anytime by deleting your profile.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("C. Age Verification via Third-Party (Didit)")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Data collected:")
            }
            org.jetbrains.compose.web.dom.Text(" Identity documents or facial geometry verification data.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Purpose:")
            }
            org.jetbrains.compose.web.dom.Text(" To ensure our platform is strictly for users aged 18 and older.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Legal Basis:")
            }
            org.jetbrains.compose.web.dom.Text(" Our ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("legitimate interest")
            }
            org.jetbrains.compose.web.dom.Text(" (Art. 6 (1) (f) GDPR) to protect our community and prevent minors from accessing adult services, combined with your explicit consent for biometric verification elements.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Note:")
            }
            org.jetbrains.compose.web.dom.Text(" The technical verification is executed by Didit. We do not store your raw identity documents; we only receive a \"verified\" or \"failed\" confirmation.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("D. Precise Geolocation Data")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Data collected:")
            }
            org.jetbrains.compose.web.dom.Text(" Real-time GPS coordinates from your mobile device.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Purpose:")
            }
            org.jetbrains.compose.web.dom.Text(" To calculate distances and match you with nearby users.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Legal Basis:")
            }
            org.jetbrains.compose.web.dom.Text(" Your ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("consent")
            }
            org.jetbrains.compose.web.dom.Text(" (Art. 6 (1) (a) GDPR), granted via your device's operating system permissions.")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("3-community-safety-banning-and-moderation") }) {
        org.jetbrains.compose.web.dom.Text("3. COMMUNITY SAFETY, BANNING, AND MODERATION")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("To maintain a safe platform, users can report suspicious or malicious profiles to our administrators.")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("When a report is filed, we process the data of the reported profile and the reason for the report.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Legal Basis:")
            }
            org.jetbrains.compose.web.dom.Text(" Our ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("legitimate interest")
            }
            org.jetbrains.compose.web.dom.Text(" (Art. 6 (1) (f) GDPR) to protect users from fraud, spam, and harassment.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Human-in-the-loop Rule:")
            }
            org.jetbrains.compose.web.dom.Text(" All profile suspensions, penalties, or permanent bans are finalized via ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("direct human review")
            }
            org.jetbrains.compose.web.dom.Text(" by our administrators. No automated profiling or automated bans are implemented.")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("4-data-retention-policy") }) {
        org.jetbrains.compose.web.dom.Text("4. DATA RETENTION POLICY")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We retain your personal data only as long as your account is active.")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Upon voluntary unsubscription or account deletion, your profile data, photos, and geolocation history are ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("permanently deleted or within 30 days")
            }
            org.jetbrains.compose.web.dom.Text(", unless a longer retention period is required by tax law (for paid subscriptions) or to enforce active safety bans.")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("5-data-recipients-and-transfers") }) {
        org.jetbrains.compose.web.dom.Text("5. DATA RECIPIENTS AND TRANSFERS")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Your data is shared only with trusted technical processors under strict Data Processing Agreements (DPA):")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Cloud Hosting & Infrastructure: Google Cloud Platform / Firebase (Data is hosted strictly on servers located within the European Economic Area - EEA).")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Identity & Age Verification: Didit.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Payment Processing: Stripe (All credit card details are encrypted and handled directly by Stripe; we do not store raw card numbers on our servers).")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("International Transfers:")
            }
            org.jetbrains.compose.web.dom.Text(" All data is stored within the European Economic Area (EEA).")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("your-rights-as-a-data-subject") }) {
        org.jetbrains.compose.web.dom.Text("YOUR RIGHTS AS A DATA SUBJECT")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Under Articles 15–22 of the GDPR, you have the following rights, exercisabele ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("free of charge")
        }
        org.jetbrains.compose.web.dom.Text(" at any time:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Right of access:")
            }
            org.jetbrains.compose.web.dom.Text(" Request a copy of your data.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Right to rectification:")
            }
            org.jetbrains.compose.web.dom.Text(" Correct inaccurate data.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Right to erasure (\"to be forgotten\"):")
            }
            org.jetbrains.compose.web.dom.Text(" Request account deletion.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Right to restrict processing & Object to processing.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Right to data portability:")
            }
            org.jetbrains.compose.web.dom.Text(" Request your data in a structured format.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("To exercise these rights, email us at: ")
        com.varabyte.kobweb.silk.components.navigation.Link("mailto:groszvilmos@willandsons.com") {
            org.jetbrains.compose.web.dom.Text("groszvilmos@willandsons.com")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("7-right-to-lodge-a-complaint") }) {
        org.jetbrains.compose.web.dom.Text("7. RIGHT TO LODGE A COMPLAINT")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you believe your data protection rights have been violated, you have the right to lodge an official complaint with the competent supervisory authorities:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("In Romania:")
            }
            org.jetbrains.compose.web.dom.Text(" Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("ANSPDCP")
            }
            org.jetbrains.compose.web.dom.Text("), B-dul G-ral. Gheorghe Magheru 28-30, Sector 1, Bucharest (")
            com.varabyte.kobweb.silk.components.navigation.Link("mailto:anspdcp@dataprotection.ro") {
                org.jetbrains.compose.web.dom.Text("anspdcp@dataprotection.ro")
            }
            org.jetbrains.compose.web.dom.Text(").")
        }
    }
    org.jetbrains.compose.web.dom.H1(attrs = { id("updating-the-personal-data-protection-and-processing-policy") }) {
        org.jetbrains.compose.web.dom.Text("UPDATING THE PERSONAL DATA PROTECTION AND PROCESSING POLICY")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our users are asked to bear in mind that this Policy may be subject to periodic changes in content, as well as the updating of the Willandsons Services SRL app. Therefore, it is necessary to check this Policy for any updates.")
    }
}
